import type { ReportFocus, StatusFilter } from '../types';

export function reportCacheKey(
  appId: string | null,
  range: string,
  focus: ReportFocus,
  statusFilter?: StatusFilter,
) {
  return `agent-actions-report:${appId || 'all'}:${range}:${focus}:${statusFilter || 'all'}`;
}

export function parseHealthScore(report: string): number | null {
  const m = report.match(/Platform health score[\s\S]*?\b(\d{1,3})\b/i);
  if (!m) return null;
  const n = Number(m[1]);
  return Number.isFinite(n) ? Math.min(100, Math.max(0, n)) : null;
}

export function healthScoreLabel(score: number | null) {
  if (score == null) return { text: '—', className: 'bg-gray-100 text-gray-600' };
  if (score >= 80) return { text: `${score}/100 · Healthy`, className: 'bg-green-100 text-green-700' };
  if (score >= 60) return { text: `${score}/100 · Attention needed`, className: 'bg-amber-100 text-amber-700' };
  return { text: `${score}/100 · Issues found`, className: 'bg-red-100 text-red-700' };
}

export function extractCursorPrompt(report: string): string {
  const section = report.match(/### Cursor prompt[\s\S]*/i)?.[0] || report;
  const fenced = section.match(/```(?:markdown)?\n([\s\S]*?)```/i);
  if (fenced?.[1]) return fenced[1].trim();
  const noFix = section.match(/No fixes needed[\s\S]*/i);
  return noFix?.[0]?.trim() || '';
}

export function stripCursorPromptSection(report: string): string {
  return report.replace(/### Cursor prompt[\s\S]*/i, '').trim();
}
